// extracted by mini-css-extract-plugin
module.exports = {"name":"styles_name__sMiwy","title":"styles_title__guh7y"};